import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Tag} from "../tags/types.ts";

export type MessageDimension = { name: string, value: string }

export enum MessageStatus {
    READ = 'READ',
    UNREAD = 'UNREAD',
    SENT = 'SENT',
    DELETED = 'DELETED',
    ARCHIVED = 'ARCHIVED',
}

export type Message = {
    id: string,
    messageId?: string,
    from?: string[],
    fromText?: string,
    fromHtml?: string,
    to?: string[],
    toText?: string,
    toHtml?: string,
    subject?: string,
    date?: string,
    parsedPath?: string,
    parsedObjectKey?: string,
    htmlPath?: string,
    htmlObjectKey?: string,
    textPath?: string,
    textObjectKey?: string,
    textAsHtmlPath?: string,
    textAsHtmlObjectKey?: string,
    // FNP-1532: NO key material. `objectKey` embedded the owning tenant's
    // identityId and was handed to every caller; it is gone from the API type.
    // Download one via fetchAttachmentUrl(messageId, index) — the index into
    // THIS array is the selector.
    attachments?: { filename: string }[],
    status?: MessageStatus,
    aliasId?: string,
    tagIds?: string[],
    tags?: { items: Tag[] | null },
    inReplyTo?: string,
    createdByUsername?: string,
    managedByUsername?: string,
    created?: string,
    updated?: string,
}


export interface IMessageTableColumn extends ITableColumn {
    render?: (item: Message) => ReactNode;
}

export type ListMessages = {
    listMessages: { items: Message[], nextToken: string | null }
}

export type GetMessage = {
    getMessage: Message
}

// FNP-1532: the body, served by the API instead of fetched from S3.
export type MessageBody = {
    messageId: string,
    textBody: string | null,
    htmlBody: string | null,
    truncated: boolean | null,
    /** Which artifact was served: 'text' | 'parsed' | 'html'. Branch on it when you need plain text. */
    contentType: string | null
}

export type GetMessageBody = {
    getMessageBody: MessageBody | null
}

// FNP-1532: a short-lived, single-object download URL. Bearer credential —
// fetch it, do not store or log it.
export type AttachmentUrl = {
    filename: string | null,
    url: string,
    expiresAt: string
}

export type GetAttachmentUrl = {
    getAttachmentUrl: AttachmentUrl | null
}

export type CreateMessage = {
    createMessage: Message
}

export type UpdateMessage = {
    updateMessage: Message
}

// FNP-1672: the only fields the app ever changes on a message. Writes carry the
// change, never the loaded record: echoing it sent null *ObjectKey fields that
// the API's FNP-1542 guard refuses, and would otherwise have erased.
export const MESSAGE_WRITABLE_FIELDS = ['status', 'tagIds'] as const;

export type MessagePatch = Partial<Pick<Message, typeof MESSAGE_WRITABLE_FIELDS[number]>>;

export type DeleteMessage = {
    deleteMessage: string
}
